export enum EventTicketValidationAction {
    Store,
    Update,
}
